module.exports = __webpack_public_path__ + "img/bg3Copy-1.c11ef69c.png";